import { useQuery } from '@tanstack/react-query';

import { janeApiV2 } from '@jane/shared/data-access';
import type { NuProductType } from '@jane/shared/types';

export const PRODUCT_TYPES_URL = '/business/product_types';

const fetchProductTypes = (): Promise<NuProductType[]> =>
  janeApiV2.get<NuProductType[]>(PRODUCT_TYPES_URL);
export const useProductTypes = () =>
  useQuery<NuProductType[]>({
    placeholderData: [],
    queryFn: () => fetchProductTypes(),
    queryKey: ['productTypes'],
    staleTime: Infinity,
    throwOnError: true,
  });
